module.exports = __webpack_public_path__ + "img/w4.039acf9a.png";